import './ProductItem.css'
import React, { useState } from 'react'
import { decode } from 'html-entities'
import ProductItemPrice from './productItemPrice/ProductItemPrice'

/**
 * Структура данных товара
 *
 * [ID] => 146181
 * [NAME] => Apple iPhone 12 128 Gb Black
 * [CODE] => apple-iphone-12-128-gb-black
 * [XML_ID] => 0d5939b7-0d80-11eb-9621-00155d11aa02
 * [ARTICLE] => MGJA3/MGHC3
 * [AVAILABLE_STATE] => 1
 * [RATING] => 5
 * [COUNT_REVIEWS] => 3
 * [PICTURE] => Array
 *      (
 *        [owner] => 0d5939b7-0d80-11eb-9621-00155d11aa02
 *        [src] => https://cdn.tehnoezh.ua/0/0/0/0/1/3/8/9/8/000013898_545_545.jpeg
 *        [alt_src] => https://cdn.tehnoezh.ua/0/0/0/0/1/3/8/9/8/000013898_545_545.webp
 *        [width] => 545
 *        [height] =>
 *        [index] => 0
 *        [alt] => Apple iPhone 12 128 Gb Black
 *        [title] => Apple iPhone 12 128 Gb Black
 *      )
 * [DISPLAY_PRICE] => Array
 *  (
 *    [PRICE] => 31995
 *    [BASE_PRICE] => 31995.00
 *    [RAW_DISCOUNT_PRICE] => 31995.00
 *    [DISCOUNT_PRICE] => 31995.00
 *    [PRINT_PRICE] => 31 995 грн
 *    [PRINT_PRICE_USD] => 804 $
 *    [OLD_PRICE] => 32599
 *    [PRINT_OLD_PRICE] => 32 599 грн
 *  )
 *
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
function ProductItem (props) {
  /**
   * Формирование звезд
   * @return {*[]}
   */
  const stars = () => {
    let stars = []
    for (let i = 1; i <= 5; i++) {
      (props.RATING >= i) ?
        stars.push(<span className="star-mini full" key={i}></span>) :
        stars.push(<span className="star-mini" key={i}></span>)
    }
    return stars
  }

  function plural (countReviews) {
    countReviews = countReviews % 100
    let countReviews_1 = countReviews % 10
    if (countReviews > countReviews && countReviews < 20) return 'REVIEW_CNT_5'
    if (countReviews_1 > 1 && countReviews_1 < 5) return 'REVIEW_CNT_2'
    if (countReviews_1 === 1) return 'REVIEW_CNT_1'
    return 'REVIEW_CNT_5'
  }

  function pricePercentDiff() {
    let priceDiff = Math.ceil(parseInt(props.OLD_PRICE) - parseInt(props.PRICE))
    return Math.ceil(priceDiff * 100 / parseInt(props.OLD_PRICE))
  }

  return (
    <div className="product-item">
      {
        props.hasOwnProperty('OLD_PRICE') && parseInt(props.OLD_PRICE) > 0 &&
        props.hasOwnProperty('PRICE') && parseInt(props.PRICE) ?
          <div className="product-label"><span className="label-discount">-{pricePercentDiff()}%</span></div> :
          <></>
      }
      <div className="img">
        <a href={props.URL}>
          <img src={props.IMAGE_379_SRC}
               alt={props.NAME_UA}
               title={props.NAME_UA}
               height={'379px'}
               width={'379px'}
               loading={'lazy'}/>
        </a>
      </div>
      <div className="product-descr">
        <div className="code"><span>{props.ARTICLE}</span></div>
        <div className="rate-row">
          <div className="rate">{stars()}</div>
          <div className="product-reviews">
            <a
              href={`${props.URL}#section-testimonials`}>{props.COUNT_REVIEWS} {props.getMessage(plural(props.COUNT_REVIEWS))}</a>
          </div>
        </div>
        <div className="product-name"><a href={props.URL}>{decode(props.NAME)}</a></div>
        {
          props.hasOwnProperty('PRICE') && parseInt(props.PRICE) > 0 ?
            <ProductItemPrice {...props}/> :
            <></>
        }
      </div>
    </div>
  )
}

export default ProductItem